import { useEffect, useState } from 'react';

/** Vrai en dessous de 900 px — le seuil où la barre latérale disparaît. */
export function useMobile(): boolean {
  const [mobile, setMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(max-width:900px)').matches,
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width:900px)');
    const h = (e: MediaQueryListEvent) => setMobile(e.matches);
    mq.addEventListener('change', h);
    return () => mq.removeEventListener('change', h);
  }, []);
  return mobile;
}
